import React, { useEffect, VFC } from 'react';
import { Container, Col } from 'react-grid-system';
import Spacing from '../components/atoms/Spacing';
import SectionHeader from '../components/organisms/SectionHeader';
import ProductListItem from '../components/organisms/ProductListItem';
import ListBorder from '../components/organisms/ListBorder';
import SurroundingBorder from '../components/organisms/SurroundingBorder';
import { useProductContext } from '../contexts/productContext';
import MissingData from '../components/molecules/MissingData';
import Loader from '../components/molecules/Loader';

const ProductReturnPage: VFC = () => {
  const { productList, loading: loadingProduct, searchForDefaultProducts } = useProductContext();

  useEffect(() => {
    searchForDefaultProducts();
  }, []);

  return (
    <SurroundingBorder>
      <SectionHeader />
      {loadingProduct ? (
        <Loader color="white" />
      ) : (
        <div>
          {productList?.length === 0 && !loadingProduct ? (
            <MissingData />
          ) : (
            <Container>
              <ListBorder>
                <Col>
                  <Spacing spacing={4} />
                  {productList?.map((item) => (
                    <ProductListItem
                      key={item.imageUrl + item.productNumber}
                      {...item}
                    />
                  ))}
                </Col>
              </ListBorder>
            </Container>
          )}
        </div>
      )}
    </SurroundingBorder>
  );
};

export default ProductReturnPage;
